import "./UnAuthorizedPage.css";
import React, { Fragment } from "react";
import logo from "../../assets/images/landbook.png";

const UnAuthorizedPage = () => {
  return (
    <Fragment>
      <div className="error-body-container">
        <div className="not-found-page">
          <div className="not-found-page-land-book-logo">
            <img src={logo} alt="" />
          </div>
          <div className="not-found-content">
            <h1 className="not-found-title">403</h1>

            <h2 className="not-found-sec-heading">
              Oops! This Page Could Not Be Accessed
            </h2>
            <p className="not-found-subtitle">
              Sorry, you are not authorized to access this resource.
            </p>
            {/* <Link to="/user/dashboard" className="goToButton">Go To Dashboard</Link> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UnAuthorizedPage;
